import api from "./api";
import { API_URL_VERSION } from "../constants/environment";
import {toSearchFilter} from "../utils";

export const ENDPOINT_PRINT_NPS_LIST = API_URL_VERSION + 'lotes/imprimir-nps'
export const ENDPOINT_PRINT_NPS = API_URL_VERSION + 'print-nps'
export const ENDPOINT_PRINT_NPS_GET_DETAIL_UPDATE = API_URL_VERSION + 'print-nps/'
export const ENDPOINT_PRINT_NP = API_URL_VERSION + 'lotes/imprimir-np-pdf'
export const ENDPOINT_CONFIRM_SHIPPING_NP = API_URL_VERSION + "lotes/confirmar-envio-np"
export const ENDPOINT_RESPONSE_FILE_NP = API_URL_VERSION + "lotes/arquivo-resposta-correios-np"
export const ENDPOINT_REPORT_BATCH = API_URL_VERSION + "lotes/imprimir-detalhes-lote-np-pdf"
export const ENDPOINT_REPORT_EDITAL_BATCH = API_URL_VERSION + "lotes/imprimir-edital-np-pdf"

export const printNPsService = {
    list: async (params) => {
        try {
            const searchParams = toSearchFilter(params);
            const response = await api.post(ENDPOINT_PRINT_NPS_LIST, searchParams);
            return response?.data ?? [];
        } catch (error) {
            throw error.response?.data?.message || "error.print-nps.list";
        }
    },

    findMany: async (data) => {
        try {
            const response = await api.get(ENDPOINT_PRINT_NPS_LIST, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'error.print-nps.findmany';
        }
    },

    create: async (data) => {
        try {
            const response = await api.post(ENDPOINT_PRINT_NPS, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'error.print-nps.create';
        }
    },

    find: async (id: number) => {
        try {
            const response = await api.get(`${ENDPOINT_PRINT_NPS_GET_DETAIL_UPDATE}${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'error.print-nps.find';
        }
    },

    update: async (id: number, data) => {
        try {
            const response = await api.put(`${ENDPOINT_PRINT_NPS_GET_DETAIL_UPDATE}${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'error.print-nps.update';
        }
    },

    printNp: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_PRINT_NP}/${id}`, {
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            // Blob error response
            const errorJson = JSON.parse(await error.response.data.text());
            throw errorJson?.message || errorJson?.erros_validacao || 'print-nps.messages.errors.print-np';
        }
    },

    getResponseFileNp: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_RESPONSE_FILE_NP}/${id}`, {
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            // Blob error response
            const errorJson = JSON.parse(await error.response.data.text());
            throw errorJson?.message || errorJson?.erros_validacao || 'print-nps.messages.errors.response-file-np';
        }
    },

    confirmShippingNp: async (id) => {
        try {
            const response = await api.put(`${ENDPOINT_CONFIRM_SHIPPING_NP}/${id}`)
            return response.data;
        } catch (error) {
            throw error.response?.data?.erros_validacao || 'print-nps.messages.errors.confirm-shipping-np';
        }
    },

    getReportNp: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_REPORT_BATCH}/${id}`, {
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            throw error.response?.data?.message || 'print-nps.messages.errors.details-file-np';
        }
    },

    getEditalReportNp: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_REPORT_EDITAL_BATCH}/${id}`, {
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            throw error.response?.data?.message || 'print-nps.messages.errors.edital-file-np';
        }
    }

};
